import { GcmState } from '@/features/game-window-integration/helpers/GCM/types';

const initialGcmState: GcmState = {
  gcm: undefined,
  showErrorDialog: true,
  showMsgTriggerDialog: true,
  haveOwnCui: false,
  regression: false,
  osgParams: null,
  options: {},
  errorCallback: null,
  dialogTitle: '',
  dialogText: '',
  dialogErrorCode: '',
  progressTimeout: null,
  initComplete: false,
};

export const gcmState: GcmState = { ...initialGcmState };

export const resetGcmState = (): void => {
  if (gcmState.progressTimeout) {
    clearTimeout(gcmState.progressTimeout);
  }
  Object.assign(gcmState, { ...initialGcmState });
};
